import Button from "../../../../components/Button";
import EventModal from "../../../projects/pages/project/components/EventModal";
import { useState } from "react";
import {
  EventFragment,
} from "../../../../__generated__/graphql";
import { FaPlus } from "react-icons/fa6";

interface CreateEventButtonProps {
  variant?: "primary" | "secondary";
  projectId?: string;
  onEventCreated?: (event: EventFragment) => void;
  buttonText?: string;
  defaultStartDate?: string; // Format: YYYY-MM-DD
}

export default function CreateEventButton({
  variant = "primary",
  projectId,
  onEventCreated,
  buttonText = "Créer un évènement",
  defaultStartDate,
}: CreateEventButtonProps) {
  const [isCreateEventModalOpen, setIsCreateEventModalOpen] = useState(false);

  return (
    <>
      <EventModal
        isOpen={isCreateEventModalOpen}
        onClose={() => setIsCreateEventModalOpen(false)}
        onNewEvent={(event) => {
          onEventCreated?.(event);
        }}
        projectId={projectId}
        defaultStartDate={defaultStartDate}
      />

      <Button
        variant={variant}
        className="text-sm"
        onClick={() => setIsCreateEventModalOpen(true)}
        dataTestId="create-event-button"
      >
        <FaPlus className="w-4 h-4 mr-2" />
        {buttonText}
      </Button>
    </>
  );
}
